import { MetadataService } from './../../../../BaseFramework/core/http/metadata.service';
import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { IntimationService } from '../../../../BaseFramework/core/http/intimation.service';
import * as moment from 'moment/moment';
import { from } from 'rxjs';
import {
  InteractService, ApiRequestService, UserInfoService, AppMetadataHandler
} from 'app'
//import { default as configData } from './search-intimation.component.json';
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: any;
  isMandatory: Boolean;
}

@Component({
  selector: 'search-intimation',
  templateUrl: './search-intimation.component.html',
  styleUrls: ['./search-intimation.component.scss']
})
export class SearchIntimationComponent implements OnInit {
  public searchResultList = []
  public CRITERIALOOKUP = [];
  public dataSet = [];
  public intimationType = null
  public viewType = null
  public intimationZeroState = {
    title: "Search Required",
    message: "Hit search to view results",
    icon: "file-search"
  }
  constructor(private router: Router,
    private intimationService: IntimationService,
    private metadataService: MetadataService,
    private interactService: InteractService,
    private userInfoService: UserInfoService,
    private apiRequestService: ApiRequestService,
    private activatedRoute: ActivatedRoute,
    public appMetadataHandler: AppMetadataHandler) { }

  ngOnInit() {

    this.activatedRoute.data.subscribe(data => {
      this.intimationType = data.intimationType
      this.viewType = data.viewType
      this.getIntimationSearchCriteriaList();
      // this.getLatestFiveIntimation(); // Will take latest five  intimations
    });
  }


  NewIntimation(inboxType) {
    // this.interactService.openNewTransaction(null,null,null,configData.IntimationTypeServiceTaskToIntimationSourceCdMapper[this.intimationType], configData.IntimationTypeToIntimationSourceCdMapper[this.intimationType], inboxType)
  }

  fetchSearchResult($event) {
    console.log("123");
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.dataSet = $event.results;
        console.log(this.dataSet)
        if (!this.dataSet || (this.dataSet && this.dataSet.length == 0)) {
          this.intimationZeroState.title = "No Results found"
          this.intimationZeroState.message = "No records available for the selected search criteria."
        }
      }
      else{
        this.dataSet = []
      }
    }
    else{
        this.getLatestFiveIntimation()
    }
  }

  getIntimationSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchIntimation')
      .subscribe(jsonResp => {
        if (jsonResp && Array.isArray(jsonResp)) {
          jsonResp.forEach(criteria => {
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
      })
  }
  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  openTransactionDetails(serviceTask: any, entityGuid: any, inboxType: any) {
    let transactionDataIO: any = [];
    this.intimationService.getIntimationByGuid(entityGuid).
      subscribe(resp => {
        transactionDataIO = resp;
        this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, null, null, inboxType)
        if (this.viewType == "ENQUIRY")
          this.router.navigate(['/app/claims/transaction/enquiry'], { queryParams: {}, replaceUrl: false });
        else
          this.router.navigate(['/app/claims/transaction/details'], { queryParams: {}, replaceUrl: false });
      });
  }

  itemsPerPage: any = 1;
  currentPage: any = 5;
  searchURL = "claim/Intimation/search"
  getLatestFiveIntimation() {
    var payload = {}
    payload["page"] = this.currentPage;
    payload["size"] = this.itemsPerPage;
    payload["searchCriteriaList"] = []
    var criteriaItem = {}
    let userId = null
    userId = this.userInfoService.getUserId();
    criteriaItem = {}
    criteriaItem["paramName"] = 'criteriaUser'
    criteriaItem["paramValue"] = userId
    payload["searchCriteriaList"].push(criteriaItem)
    this.apiRequestService.post(this.searchURL, payload).subscribe(data => {
      this.dataSet = data.results;
    });

  }


}
